import { Skeleton } from "@/components/ui/skeleton";
import { PackageSearch, AlertTriangle } from "lucide-react";

export function ProductGridSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 lg:gap-x-8">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex flex-col gap-3">
          <Skeleton className="aspect-[4/5] w-full rounded-none bg-black/5" />
          <Skeleton className="h-3 w-16 bg-black/5" />
          <Skeleton className="h-5 w-32 bg-black/5" />
          <Skeleton className="h-3 w-40 bg-black/5" />
          <Skeleton className="h-4 w-14 bg-black/5" />
        </div>
      ))}
    </div>
  );
}

export function EmptyState({ onReset }: { onReset: () => void }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 border border-dashed border-black/15 bg-[#faf7f2] px-6 py-24 text-center"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <PackageSearch className="h-8 w-8 text-[#C6A15B]" strokeWidth={1.2} />
      <h3
        className="text-xl font-normal text-black"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        No fragrances match your search
      </h3>
      <p className="max-w-sm text-sm text-black/60">
        Try broadening your filters or explore the full collection.
      </p>
      <button
        type="button"
        onClick={onReset}
        className="mt-2 border border-black px-6 py-2 text-[11px] font-medium uppercase tracking-[0.28em] text-black transition hover:border-[#C6A15B] hover:text-[#C6A15B]"
      >
        Reset filters
      </button>
    </div>
  );
}

export function ErrorState({ onRetry }: { onRetry: () => void }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 border border-dashed border-black/15 bg-[#faf7f2] px-6 py-24 text-center"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <AlertTriangle className="h-8 w-8 text-[#C6A15B]" strokeWidth={1.2} />
      <h3
        className="text-xl font-normal text-black"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        Something went wrong
      </h3>
      <p className="max-w-sm text-sm text-black/60">
        We couldn't load the catalog. Please try again in a moment.
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-2 border border-black px-6 py-2 text-[11px] font-medium uppercase tracking-[0.28em] text-black transition hover:border-[#C6A15B] hover:text-[#C6A15B]"
      >
        Try again
      </button>
    </div>
  );
}
